var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1932.183,
    height: 459.697,
    viewBox: "0 0 1932.183 459.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M7386.85,16665.789s174.41-201.262,519.53-114.678,354.533-73.262,486.306-93.242,230.354,62.461,460.956,19.168,442.9-63.236,464.864-203.1c1.186-7.553,0-62.072,0-62.072l-1931.656-5.771Z",
    transform: "translate(-7386.85 -16206.092)",
    fill: "#0476d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBanner);
export default __webpack_public_path__ + "static/media/home_banner.74d86c78f6caf92fe4ff7ac442ab1eb4.svg";
export { ForwardRef as ReactComponent };